<template>  
  <div :class="classCard" :id="divId">
    <div class="card-up"></div>
    <div class="">
        <img :src="imagePath" class="img-fluid">
    </div>

    <div class="card-body">        
        <span v-html="title"></span>
    </div>
    <div class="card-up"></div>
</div>  
</template>

<script>

///import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'MainTile',
  data: function() {
    return  {
      
    };
  },
  props: ['image','title','dimensionCard','divId'],
  methods: {    
  },
  computed: {    
      imagePath: function() {
          return require("../assets/images/" + this.image);
      },
      classCard: function() {
        return "card color-grey text-white " + this.dimensionCard;
      },
     
  }
}
</script>


